import {
  fetchPositionCode,
  fetchEmployees,
} from "@api/procurements/procurementWorkFlow";
import { useEffect, useState } from "react";

export const useProcurementFlow = () => {
  const [employees, setEmployees] = useState([]);
  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    positionCode: "",
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    fetchPositionCode()
      .then((data) => {
        fetchEmployees(data.data?.nextReviewerPositionCode)
          .then((data) => {
            setEmployees(data.data.commonInfo);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (query?.positionCode) {
      fetchEmployees(query.positionCode)
        .then((data) => {
          setEmployees(data.data.commonInfo);
        })
        .catch((err) => console.log(err));
    }
  }, [query]);

  return {
    handleQuery,
    employees,
  };
};
